import React, { createContext, useState, useMemo } from "react";
import {
  getFirestore,
  collection,
  getDocs,
  orderBy,
} from "firebase/firestore";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { collections, mapDocs } from "../utils";

const OrdersContext = createContext();

const OrdersContextProvider = ({ children }) => {
  const [statusFilter, setStatusFilter] = useState("");
  const [dateFilter, setDateFilter] = useState([
    dayjs().startOf("month"),
    dayjs().endOf("month"),
  ]);

  const querydb = getFirestore();

  const { data: orders = [], isLoading, isError, error, refetch } = useQuery(
    ["orders", dateFilter, statusFilter],
    async () => {
        let orderQuery = collection(querydb, collections.orders);
        const rawOrders = await getDocs(orderQuery, orderBy("dateStart", "asc"));
        return mapDocs(rawOrders);
    },
    {
        enabled: true,
    }
  );

  const {
    filteredOrdersByStart,
    filteredOrdersByEnd,
    totalSalesForDateRange,
} = useMemo(() => {
    let filteredStart = orders ?? [];
    let filteredEnd = orders ?? [];
    let totalSales = 0;

    if (dateFilter) {
        let startDate = dateFilter[0].toDate();
        startDate.setHours(0, 0, 0, 0);
        let endDate = dateFilter[1].toDate();
        endDate.setHours(23, 59, 59, 999);

        let startDateSeconds = startDate.getTime() / 1000;
        let endDateSeconds = endDate.getTime() / 1000;

        filteredStart = filteredStart
            .filter(order => order.dateStart.seconds >= startDateSeconds && order.dateStart.seconds <= endDateSeconds)
            .sort((a, b) => a.dateStart.seconds - b.dateStart.seconds);

        filteredEnd = filteredEnd
            .filter(order => order.dateEnd.seconds >= startDateSeconds && order.dateEnd.seconds <= endDateSeconds)
            .sort((a, b) => a.dateEnd.seconds - b.dateEnd.seconds);
    }

    // Filtrado por estado solo para filteredOrdersByStart
    if (statusFilter.length > 0 && !statusFilter.includes("Todos los estados")) {
        filteredStart = filteredStart.filter((order) => statusFilter.includes(order.status));
    }

    totalSales = filteredStart.reduce(
        (accumulator, current) => accumulator + current.saleAmount, 0
    );

    return {
        filteredOrdersByStart: filteredStart,
        filteredOrdersByEnd: filteredEnd,
        totalSalesForDateRange: totalSales,
    };
}, [orders, dateFilter, statusFilter]);


  if (isLoading) return <h1 className="mt-5">Cargando...</h1>;
  if (isError) return <pre>{JSON.stringify(error)}</pre>;

  return (
    <OrdersContext.Provider
      value={{
        dataOrders: orders,
        dateFilter,
        filteredOrdersByStart,
        filteredOrdersByEnd,
        statusFilter,
        totalSalesForDateRange,
        setStatusFilter,
        setDateFilter,
        refetch
      }}
    >
      {children}
    </OrdersContext.Provider>
  );
};

export { OrdersContext, OrdersContextProvider };
